import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { AvatarModule } from 'primeng/avatar';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { SliderModule } from 'primeng/slider';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { CardModule } from 'primeng/card';

export const modules = [
  TableModule,
  TooltipModule,
  DynamicDialogModule,
  TabViewModule,
  InputTextModule,
  ButtonModule,
  FormsModule,
  TooltipModule,
  AvatarModule,
  DividerModule,
  SliderModule,
  CalendarModule,
  ReactiveFormsModule,
  DropdownModule,
  InputTextareaModule,
  RadioButtonModule,
  ToggleButtonModule,
  AutoCompleteModule,
  ConfirmPopupModule,
  TagModule,
  CardModule
];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...modules],
  exports: [...modules],
  providers: [DialogService, ConfirmationService],
})
export class PrimengModule {}
